import { render } from "./HomeiconIphone.vue?vue&type=template&id=c68c4b0e&scoped=true"
import script from "./HomeiconIphone.vue?vue&type=script&lang=js"
export * from "./HomeiconIphone.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c68c4b0e"

export default script